import { CALL_API } from '../../../middleware/api';

const LOAD = 'gallery/LOAD';
const LOAD_SUCCESS = 'gallery/LOAD_SUCCESS';
const LOAD_FAIL = 'gallery/LOAD_FAIL';


export const load = () => ({
  [CALL_API]: {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    endpoint: 'gallery/',
    method: 'GET'
  }
});


// WEBPACK FOOTER //
// ./src/redux/modules/gallery/index.js